<template>
    <v-container>
        <v-row class="mt-3" align="center">
            <v-col cols="12" md="8">
                <div class="headline-light secondary-color">
                    Perfil {{ currentEntityLabel }}
                </div>
                <div class="display-heavy primary-color">
                    Panel Pack examenes
                </div>
            </v-col>
            <v-col cols="12" md="4">
                <graphics-card
                    title="Total Packs"
                    :number="totalPacks"
                    icon="mdi-package"
                    color="#F4F7FE"
                />
            </v-col>
            <v-col cols="12" align="right">
                <v-btn class="normal-btn" color="primary" outlined large @click="addPack">
                    Agregar Pack
                </v-btn>
            </v-col>
            <v-col cols="12">
                <kimsa-data-table
                    :headers="headers"
                    :items="packs"
                    :loading="loadingPacks"
                    @action="onAction"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import GraphicsCard from "@/components/cards/GraphicsCard";
import KimsaDataTable from "@/components/common/KimsaDataTable";
import httpService from "@/services/httpService";
export default {
    name: "Packs",
    components: {KimsaDataTable, GraphicsCard},
    data() {
        return {
            headers: [
                {text: 'Nombre Pack', value: 'name'},
                {text: 'Examenes', value: 'exams'},
                {text: '', value: 'actions'},
            ],
            packs: [],
            loadingPacks: false,
        }
    },
    computed: {
        totalPacks(vm = this) {
            return vm.statsDashboard?.total_packs || 0
        },
    },
    async mounted() {
        const vm = this
        if(vm.currentEntityId) await vm.loadPacks()
    },
    methods: {
        async loadPacks() {
            const vm = this
            vm.loadingPacks = true
            let response = await httpService.get(`laboratory/${vm.currentEntityId}/packs`)
            // console.log('response loadPacks',response)
            vm.packs = response.data.packs.map(pack => ({
                ...pack,
                exams: pack.exams.length || 0,
            }))
            vm.loadingPacks = false
        },
        addPack() {
            const vm = this
            vm.$router.push({name: 'admin.exams.packs.create'})
        },
        onAction(packId) {
            const vm = this
            vm.$router.push({name: 'admin.exams.packs.edit', params: {packId: packId}})
        }
    },
    watch: {
        currentEntityId(val) {
            if (val) this.loadPacks()
        }
    }
}
</script>

<style scoped>

</style>